<template>
  <div>
    <BarChart :chart-data="chartData" :chart-options="chartOptions" />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title);

export default {
  name: 'HorizontalBarChart',
  components: {
    BarChart: Bar,
  },
  props: {
    scores: {
      type: Array,
      default: () => [],
    },
    chartLabel: {
      type: String,
      default: 'Completion',
    },
  },
  computed: {
    chartData() {
      const labels = this.scores.map(score => score.title);
      const data = this.scores.map(score => Number(score.score || 0));

      const backgroundColors = data.map(
        (_, index) => this.chartColors[index % this.chartColors.length],
      );

      return {
        labels,
        datasets: [
          {
            label: this.chartLabel,
            data,
            backgroundColor: backgroundColors,
            borderWidth: 1,
          },
        ],
      };
    },
    chartOptions() {
      return {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            max: 100,
            ticks: {
              stepSize: 20,
              callback: value => value + '%',
              color: '#000000',
            },
            grid: {
              color: '#e0e0e0',
            },
          },
          y: {
            ticks: {
              color: '#000000',
            },
            grid: {
              display: false,
            },
          },
        },
        plugins: {
          title: {
            display: !!this.chartLabel,
            text: `${this.chartLabel} Score`,
            font: {
              size: 16,
              weight: 'bold',
            },
            color: '#000000',
            padding: {
              top: 10,
              bottom: 15,
            },
            align: 'center',
          },
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: tooltipItem => tooltipItem.raw + '%',
            },
          },
        },
      };
    },
  },
  data() {
    return {
      chartColors: [
        '#1ab7ea',
        '#0084ff',
        '#39539E',
        '#0077B5',
        '#e67e22',
        '#f39c12',
        '#2ecc71',
        '#9b59b6',
        '#ff6b6b',
      ],
    };
  },
};
</script>
